"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useFetchEffect = _ref => {
  let {
    apiFetchFunction,
    dependencies = [],
    conditionFunction = () => true,
    transformResponse = response => response,
    defaultDataState = null,
    initialDataState = null,
    initialFetchingState = false,
    initialFetchingErrorState = null,
    onSuccess = data => data,
    onError = error => error
  } = _ref;
  const [data, setData] = (0, _react.useState)(initialDataState);
  const [fetching, setFetching] = (0, _react.useState)(initialFetchingState);
  const [fetchingError, setFetchingError] = (0, _react.useState)(initialFetchingErrorState);
  const fetchData = async () => {
    setData(defaultDataState);
    setFetchingError(null);
    setFetching(true);
    const [error, response] = await apiFetchFunction();
    if (!error && response) {
      onSuccess(response);
      setData(transformResponse(response));
    } else {
      onError(error);
      setFetchingError(error);
    }
    setFetching(false);
  };
  (0, _react.useEffect)(() => {
    if (Boolean(conditionFunction(dependencies)) === true) fetchData();
  }, dependencies);
  return {
    data,
    setData,
    fetching,
    fetchData,
    fetchingError
  };
};
var _default = exports.default = useFetchEffect;